<template>
  <div class="addressBody clearfix">
        <div class="addressContent">
            <div>
                <h5>收货人</h5>
                <input type="text" placeholder="名字" v-model="name"/>
            </div>
            <div>
                <h5>手机号码</h5>
                <input type="text" placeholder="+86手机号" v-model="phone"/>
            </div>
            <div>
                <h5>所在地区</h5>
                <p @click="showAreaMenu">{{area}}</p>
                <div v-show="isShowArea" class="areaMenu">
                    <div class="areaBg"></div>
                    <van-area title="地址选择" :area-list="areaList" class="areaSelect" item-height="11.73333vw" @cancel="cancelAreaSelect" @confirm="confirmAreaSelect"/> 
                </div>
            </div>
            <div>
                <h5>详细地址</h5>
                <textarea cols="30" rows="10" placeholder="小区楼栋/乡村名称" v-model="address"></textarea>
            </div>
            
        </div>
        <div class="addressBottom">
            <div @click="saveAddress">
                保存
            </div>
        </div>
    </div>
</template>

<script>
    import { Area, Toast } from 'vant';
    import {getAllProvincesCitysDistricts, saveAddress, updateAddress} from '../api'
    export default {
        data(){
            let userArea = '省、市、区、街道'
            if(this.userProvince !== '' && this.userCity !== '' && this.userDistrict !== ''){
                userArea = this.userProvince + this.userCity + this.userDistrict
            }
            return {
                name:this.userName,
                phone:this.userTel,
                provinceName:this.userProvince,
                provinceCode:this.userProvinceCode,
                cityName:this.userCity,
                cityCode:this.userCityCode,
                districtName:this.userDistrict,
                districtCode:this.userDistrictCode,
                address:this.userAddress,
                area:userArea,
                areaList:{
                    province_list: {
                        
                    },
                    city_list: {
                       
                    },
                    county_list: {
                        
                    },
                },
                isShowArea:false
            }
        },
        components: {
            [Area.name]: Area,
        },
        props:['addressId', 'userId', 'userName', 'userTel', 'userProvince', 'userProvinceCode', 'userCity', 'userCityCode', 'userDistrict', 'userDistrictCode', 'userAddress'],
        methods:{
            showAreaMenu(){
                this.isShowArea = true
            },
            cancelAreaSelect(){
                this.isShowArea = false
            },
            confirmAreaSelect(address){
                this.isShowArea = false
                this.provinceName = address[0].name
                this.provinceCode = address[0].code
                this.cityName = address[1].name
                this.cityCode = address[1].code
                this.districtName = address[2].name
                this.districtCode = address[2].name
                this.area = this.provinceName + this.cityName + this.districtName
            },
            async saveAddress(){
                if(this.addressId === ''){
                    let result = await saveAddress(this.phone, this.name, this.provinceName, this.cityName, this.districtName, this.address, this.provinceCode, this.cityCode, this.districtCode, this.userId)
                    if(result.code === 0){
                        this.$router.push(`/prod/user/receiver?userId=${this.userId}&phone=${this.phone}`)
                    }else{
                        Toast({message: result.message, position: 'bottom'})
                    }
                    
                }else{
                    let result = await updateAddress(this.phone, this.name, this.provinceName, this.cityName, this.districtName, this.address, this.provinceCode, this.cityCode, this.districtCode, this.userId, this.addressId)
                    if(result.code === 0){
                        this.$router.push(`/prod/user/receiver?userId=${this.userId}&phone=${this.phone}`)
                    }else{
                        Toast({message: result.message, position: 'bottom'})
                    }
                    
                }
            },
            async getProvincesCitysDistricts(){
                let result = await getAllProvincesCitysDistricts()
                if(result.code === 1){
                    let provinceList = {}
                    let cityList = {}
                    let districtList = {}
                    result.data.forEach(province => {
                        provinceList[province.provinceCode] = province.provinceName
                        province.cityList.forEach(city => {
                            cityList[city.cityCode] = city.cityName
                            city.districtList.forEach(district => {
                                districtList[district.districtCode] = district.districtName
                            })
                        })
                    });
                    this.areaList.province_list = provinceList
                    this.areaList.city_list = cityList
                    this.areaList.county_list = districtList
                }else{
                    Toast({message: result.message, position: 'bottom'})
                }
            }
        },
        mounted(){
            this.getProvincesCitysDistricts()
        }
    }
</script>

<style scoped>
    .addressBody{
        height: 100%;
        background-color: #F0EFF4;
        padding-bottom: 30.4vw;
    }

    .addressContent{
        background-color: #FFFFFF;
        padding: 4.26666vw;
    }

    .addressContent>div{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4.26666vw;
        height: 12.26666vw;
        font-size: 4.26666vw;
    }

    .addressContent div input{
        width: 65.6vw;
        height: 12.26666vw;
        font-size: 3.73333vw;
        background-color: #EFEFEF;
        border:none;
        border-radius: 2.66666vw;
        padding-left: 4vw;
        color: #A4A4A4;
    }

    .addressContent div p{
        width: 65.6vw;
        height: 12.26666vw;
        font-size: 3.73333vw;
        background-color: #EFEFEF;
        border:none;
        border-radius: 2.66666vw;
        padding-left: 4vw;
        color: #A4A4A4;
        line-height: 12.26666vw;
    }

    .addressContent div .areaMenu{
        position: fixed;
        display: flex;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 10;
        flex-direction: column;
    }
    
    .addressContent div .areaMenu .areaBg{
        flex: 1;
        background-color: #000000;
        opacity: 0.8;
        
    }
    
    .addressContent div .areaMenu .areaSelect{
        position: fixed;
        bottom: 0;
        width: 100vw;
        background: #FFFFFF;
    }

    .addressContent>div:last-child{
        align-items: flex-start;
        height: 21.86666vw;
        margin-bottom: 0;
    }
    .addressContent div:last-child h5{
        margin-top: 2.93333vw;
    }
    .addressContent div:last-child textarea{
        width: 65.6vw;
        height: 18.93333vw;
        font-size: 3.73333vw;
        padding-top: 2.93333vw;
        background-color: #EFEFEF;
        border:none;
        border-radius: 2.66666vw;
        padding-left: 4vw;
        resize: none;
        color: #A4A4A4;
    }
    
    .addressBottom{
        width: 100%;
        height: 30.4vw;
        position: fixed;
        bottom: 0;
        background-color: #FFFFFF;
    }
    .addressBottom div{
        background:linear-gradient(0deg, #F4D19D, #F0B866);
        margin: 5.06666vw auto 0;
        font-size: 4.8vw;
        color: #6A421F;
        width: 84.26666vw;
        height: 11.73333vw;
        border-radius: 11.73333vw;
        text-align: center;
        line-height: 11.73333vw;
    }
</style>